import type {
  ImporterFileSource,
  ImporterSource,
} from '@canvas/tool-types/importer-types';

import { Command, type BaseCommandProperties } from '../command-definition';

export interface ImportFileCommandProperties extends BaseCommandProperties {
  /**
   * The file data to import.
   */
  blob: Blob;
  /**
   * Where the file import was initiated from, used for analytics.
   * @see canvas-frontend.entities.ts
   */
  source: ImporterSource;
  fileSource: ImporterFileSource;
}
export class ImportFileCommand extends Command<ImportFileCommandProperties> {}
